import React from 'react';
import { Search, Plus, FolderOpen } from 'lucide-react';

interface EmptyStateProps {
  /** Render as block (overlay) instead of table row */
  asBlock?: boolean;
  /** Icon variant */
  variant?: 'no-data' | 'no-results' | 'loading';
  /** Primary message */
  title?: string;
  /** Secondary description */
  description?: string;
  /** Optional action button */
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({
  asBlock = false,
  variant = 'no-data',
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  const defaults: Record<typeof variant, { icon: React.ReactNode; title: string; desc: string }> = {
    'no-data': {
      icon: <FolderOpen size={36} color="var(--border)" />,
      title: 'Пока ничего нет',
      desc: 'Список пуст. Если ждали данные — обновите страницу или снимите фильтры.',
    },
    'no-results': {
      icon: <Search size={36} color="var(--border)" />,
      title: 'Ничего не найдено',
      desc: 'По вашему запросу ничего не найдено. Попробуйте изменить фильтры.',
    },
    'loading': {
      icon: <div className="spin" style={{ display: 'inline-flex' }}><FolderOpen size={36} color="var(--border)" /></div>,
      title: 'Загрузка...',
      desc: '',
    },
  };

  const d = defaults[variant];
  const finalTitle = title ?? d.title;
  const finalDesc = description ?? d.desc;

  const content = (
    <div className="empty-state">
      <span className="empty-state-icon">{d.icon}</span>
      <div className="empty-state-title">{finalTitle}</div>
      {finalDesc && <div className="empty-state-subtitle" style={{ maxWidth: 300 }}>{finalDesc}</div>}
      {actionLabel && onAction && (
        <button onClick={onAction} className="empty-state-btn">
          <Plus size={14} /> {actionLabel}
        </button>
      )}
    </div>
  );

  if (asBlock) return content;

  return (
    <tr>
      <td colSpan={999} style={{ padding: 0, border: 'none' }}>
        {content}
      </td>
    </tr>
  );
}
